/*
 *
 *   INSPINIA - Responsive Admin Theme
 *   version 2.4
 *
 */

// jquery.metisMenu.jsが必須
function smoothlyMenu() {
  if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
    // Hide menu in order to smoothly turn on when maximize menu
    $('#side-menu').hide();
    // For smoothly turn on menu
    setTimeout(
      () => {
        $('#side-menu').fadeIn(400);
      }, 200);
  } else if ($('body').hasClass('fixed-sidebar')) {
    $('#side-menu').hide();
    setTimeout(
      () => {
        $('#side-menu').fadeIn(400);
      }, 100);
  } else {
    // Remove all inline style from jquery fadeIn function to reset menu state
    $('#side-menu').removeAttr('style');
  }
}
$(document).ready(() => {
  // MetsiMenu
  $('#side-menu').metisMenu();
  // Minimalize menu
  $('.navbar-minimalize').click(() => {
    $('body').toggleClass('mini-navbar');
    smoothlyMenu();
  });
});



// WEBPACK FOOTER //
// ./es6/admin-common-js/ui/side_manu.js